import './powered-by.css'

/**
 * The line a public footer carries saying what runs the site.
 *
 * WHAT is attributed differs, and should: a congregation's site names the
 * product it runs on, and a product's own site names the platform behind it.
 * What must not differ is the sentence and the treatment — so the words are
 * written here once and the subject is passed in.
 *
 * It takes the footer's scale and ink, and it does not underline: this is an
 * attribution rather than somewhere a visitor is being sent, told apart by its
 * place at the footer's end.
 */
export function PoweredBy({ name, href }: { name: string; href: string }) {
  return (
    <p className="powered">
      Powered by{' '}
      <a className="powered__link" href={href}>
        {name}
      </a>
    </p>
  )
}
